// import commercantJson from '../JSON/commercants.json';
import axios from 'axios';

export const shopMixin = {
	data() {
		return {
			// traderArray: commercantJson,
			traderArray: [],

			activityArray: [],
			nameTraderArray: [],
			servicesProducts: [],
			errorMessage: '',
			filterArray: [],
		};
	},
	beforeMount() {
		if (sessionStorage.getItem('commercants')) {
			this.traderArray = JSON.parse(sessionStorage.getItem('commercants'));
			this.getShopInfo();
			this.getArray();
		} else {
			this.getDataFromWS();
		}
	},
	methods: {
		getDataFromWS() {
			// 49960
			axios
				.post(
					'https://ws.vie-economique-gimont.fr/EpEtablissements.ws',
					{
						pKey: 'oQR6vwt6ku1GZX6ZcPLu70ic3abQIpyw9EiD',
						pFct: 'GetEtablissements',
						pId: '0',
						pActiviteId: '0',
						pSecteurId: '0',
						pOrderBy: '0',
						pTop: '0',
						pIdExclude: '0',
						pKeywords: '',
					},
					{
						headers: {
							'content-type': 'text/xml; charset=utf-8',
						},
					}
				)
				.then((response) => {
					this.traderArray = response.data.Table1;
					console.log(this.traderArray);
					sessionStorage.setItem('commercants', JSON.stringify(response.data.Table1));

					this.getShopInfo();
					this.getArray();
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		getShopInfo() {
			let stockTemp = [];
			for (let i = 0; i < this.traderArray.length; i++) {
				if (
					this.traderArray[i].denomination_socialeE != 0 &&
					this.traderArray[i].denomination_socialeE != 'NULL' &&
					this.traderArray[i].denomination_socialeE != '' &&
					this.traderArray[i].activiteE != 'NULL' &&
					this.traderArray[i].activiteE != ''
				) {
					stockTemp.push(this.traderArray[i]);
				}
			}
			this.traderArray = stockTemp;
		},
		deleteSpcCarac(chaine) {
			let pattern = [
				/[àáâãä]/i,
				/[éèëê]/i,
				/[ç]/i,
				/[ìíîï]/i,
				/[ñńņŉ]/i,
				/[òóôõö]/i,
				/[ùúûü]/i,
				/[ýÿ]/i,
				/[&]/i,
				/[.]/i,
				/[€]/i,
				/[/?]/i,
				/[/!]/i,
				/[/:]/i,
				/[']/i,
			];
			let replace = ['a', 'e', 'c', 'i', 'n', 'o', 'u', 'y', '', '', '', '', '', '', ''];
			for (let i = 0; i < pattern.length; i++) {
				chaine = chaine.split(pattern[i]).join(replace[i]);
			}
			return chaine;
		},
		deleteSpace(b) {
			if (b != '') {
				b = this.deleteSpcCarac(b);
				b.trim();
				b = b.split(' ').join('_');
			}
			return b;
		},
		deleteParenthesis(a) {
			if (a != '' && a != null) {
				a = a.replace(/\((.*)\)/, '');
				a.trim();
			}
			return a;
		},
		getArray() {
			let stockActivity = [];
			let stockNameTrader = [];
			let stockServicesProducts = [];
			let activity;
			let separateActivities;
			for (let i = 0; i < this.traderArray.length; i++) {
				if (
					this.traderArray[i].activiteE &&
					this.traderArray[i].activiteE != '' &&
					this.traderArray[i].activiteE != undefined &&
					this.traderArray[i].activiteE != 'NULL'
				) {
					activity = this.traderArray[i].activiteE.toUpperCase();
					separateActivities = activity.split(',');
					for (let j = 0; j < separateActivities.length; j++) {
						stockActivity.push(separateActivities[j].trim());
					}
				}
				if (
					this.traderArray[i].denomination_socialeE != '' ||
					(this.traderArray[i].denomination_socialeE &&
						this.traderArray[i].denomination_socialeE != undefined &&
						this.traderArray[i].denomination_socialeE != 'NULL')
				) {
					stockNameTrader.push(this.traderArray[i].denomination_socialeE);
				}

				if (
					this.traderArray[i].services_et_produitsE != '' ||
					(this.traderArray[i].services_et_produitsE &&
						this.traderArray[i].services_et_produitsE != undefined &&
						this.traderArray[i].services_et_produitsE != 'NULL')
				) {
					stockServicesProducts.push(this.traderArray[i].services_et_produitsE);
				}
			}
			let ActivityFilterSet = new Set(stockActivity);
			let ActivityFilterArray = [...ActivityFilterSet];

			ActivityFilterArray = ActivityFilterArray.sort();
			this.activityArray = ActivityFilterArray;
			this.nameTraderArray = stockNameTrader;
			this.servicesProducts = stockServicesProducts;
		},
		searchFilter(search) {
			if (search) {
				search.trim();
				this.deleteSpcCarac(search);
				let filter = search.toUpperCase();
				let trader = document.getElementsByClassName('shopLocation');
				if (filter != 'TOUT') {
					for (let i = 0; i < trader.length; i++) {
						let denomination = trader[i].getElementsByTagName('h2')[0];
						let activite = trader[i].getElementsByTagName('p')[0];
						let services = trader[i].getElementsByTagName('p')[1];
						let nameTrader = denomination.textContent || denomination.innerText;
						let activityTrader = activite.textContent || activite.innerHTML;
						let servicesTrader = services.textContent || services.innerHTML;
						activityTrader.trim();
						this.deleteSpcCarac(activityTrader);
						if (
							nameTrader.toUpperCase().indexOf(filter) > -1 ||
							activityTrader.toUpperCase().indexOf(filter) > -1 ||
							servicesTrader.toUpperCase().indexOf(filter) > -1
						) {
							trader[i].style.display = '';
						} else {
							trader[i].style.display = 'none';
						}
					}
				} else {
					for (let i = 0; i < trader.length; i++) {
						trader[i].style.display = 'block';
					}
				}
			}
		},
		deleteCarcNum(phone) {
			if (phone) {
				if (phone != '') {
					phone.trim();
					phone = phone.split(',').join('');
					phone = phone.split('.').join('');
					phone = phone.split(' ').join('');
				}
				return phone;
			}
		},
		replaceCarcBySpace(phone) {
			if (phone) {
				if (phone != '') {
					phone.trim();
					phone = phone.split(',').join(' ');
					phone = phone.split('.').join(' ');
				}
				return phone;
			}
		},
	},
};
